"use client";

import { ArrowRight, Feather, Sparkles, Wind } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Hypnosystemischer Ansatz",
  description: "Ein ganzheitlich-lösungsorientierter Ansatz, mit dem wir Ressourcen und Kompetenzen aktivieren und den Körper als klugen Resonanzraum mit einbeziehen. Nach Dr. Gunther Schmidt, Milton Erickson Institut.",
  icon: Sparkles,
  link: "/MyApproachPage"
}, {
  title: "Achtsamkeit / Vipassana",
  description: "Seit 2600 Jahren erprobte und mit modernen wissenschaftlichen Studien belegte Methoden, um Stress zu reduzieren, Erkenntnisse zu fördern sowie Resilienz und Weisheit nachhaltig zu entwickeln.\xA0",
  icon: Wind,
  link: "/MyApproachPage"
}, {
  title: "Embodiment",
  description: "Die Einbeziehung des Körpers als wertvolles Feedbacksystem für stimmige Entscheidungen, emotionale Regulation und nachhaltige Veränderung durch verkörperte Lösungen.",
  icon: Feather,
  link: "/MyApproachPage"
}];
export default function HealingMethods() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="108104" id="methoden-der-begleitung" className="py-24 md:py-32 bg-muted text-foreground overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl" ref={ref}>
        <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <h2 className="font-serif font-light text-4xl md:text-5xl text-center text-foreground mb-16 md:mb-24 tracking-wider">
            Methoden der <span className="heading-italic">Begleitung</span>
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {services.map((service, i) => <div key={i} data-index={i} className="group h-full">
                <Card className="h-full bg-card border border-border/40 p-8 md:p-10 transition-all duration-500 hover:-translate-y-2 hover:shadow-md hover:shadow-primary/10 hover:border-primary/30 flex flex-col rounded-xl">
                  <div className="mb-8">
                    <service.icon className="w-12 h-12 text-primary stroke-[1.5] transition-transform duration-500 group-hover:scale-110 group-hover:text-primary/80" />
                  </div>
                  
                  <h3 className="font-default text-2xl text-foreground mb-4">
                    {service.title}
                  </h3>
                  
                  {}
                  <p className="font-sans font-light text-muted-foreground leading-relaxed flex-grow mb-8 text-base">
                    {service.description}
                  </p>
                  
                  <div className="mt-auto pt-4 border-t border-border/30">
                    <Link to={service.link} className="inline-flex items-center text-sm font-medium text-primary tracking-wide uppercase transition-all group-hover:text-primary/80">
                      <span className="underline underline-offset-8 decoration-transparent transition-colors duration-300 group-hover:decoration-primary/50">
                        Mehr erfahren
                      </span>
                      <ArrowRight className="ml-3 w-4 h-4 transition-transform duration-300 group-hover:translate-x-2" />
                    </Link>
                  </div>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}